"use strict";

var _regeneratorRuntime = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var ArweaveUtils = require("./lib/utils");

var Silo =
/*#__PURE__*/
function () {
  function Silo(api, crypto, transactions) {
    _classCallCheck(this, Silo);

    this.api = api;
    this.crypto = crypto;
    this.transactions = transactions;
  }

  _createClass(Silo, [{
    key: "get",
    value: function () {
      var _get = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee(siloURI) {
        var resource, ids, transaction, encrypted;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (siloURI) {
                  _context.next = 2;
                  break;
                }

                throw new Error("No Silo URI specified");

              case 2:
                _context.next = 4;
                return this.parseUri(siloURI);

              case 4:
                resource = _context.sent;
                _context.next = 7;
                return this.transactions.search("Silo-Name", resource.getAccessKey());

              case 7:
                ids = _context.sent;

                if (!(ids.length == 0)) {
                  _context.next = 10;
                  break;
                }

                throw new Error("No data could be found for the Silo URI: ".concat(siloURI));

              case 10:
                _context.next = 12;
                return this.transactions.get(ids[0]);

              case 12:
                transaction = _context.sent;

                if (transaction) {
                  _context.next = 15;
                  break;
                }

                throw new Error("No data could be found for the Silo URI: ".concat(siloURI));

              case 15:
                encrypted = transaction.get("data", {
                  decode: true,
                  string: false
                });
                return _context.abrupt("return", this.crypto.decrypt(encrypted, resource.getEncryptionKey()));

              case 17:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function get(_x) {
        return _get.apply(this, arguments);
      }

      return get;
    }()
  }, {
    key: "readTransactionData",
    value: function () {
      var _readTransactionData = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2(transaction, siloURI) {
        var resource, encrypted;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (siloURI) {
                  _context2.next = 2;
                  break;
                }

                throw new Error("No Silo URI specified");

              case 2:
                _context2.next = 4;
                return this.parseUri(siloURI);

              case 4:
                resource = _context2.sent;
                encrypted = transaction.get("data", {
                  decode: true,
                  string: false
                });
                return _context2.abrupt("return", this.crypto.decrypt(encrypted, resource.getEncryptionKey()));

              case 7:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function readTransactionData(_x2, _x3) {
        return _readTransactionData.apply(this, arguments);
      }

      return readTransactionData;
    }()
  }, {
    key: "parseUri",
    value: function () {
      var _parseUri = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee3(siloURI) {
        var parsed, siloName, hashIterations, digest, accessKey, encryptionkey;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                parsed = siloURI.match(/^([a-z0-9-_]+)\.([0-9]+)/i);

                if (parsed) {
                  _context3.next = 3;
                  break;
                }

                throw new Error("Invalid Silo name, must be a name in the format of [a-z0-9]+.[0-9]+, e.g. 'bubble.7'");

              case 3:
                siloName = parsed[1];
                hashIterations = Math.pow(2, parseInt(parsed[2]));
                _context3.next = 7;
                return this.hash(ArweaveUtils.stringToBuffer(siloName), hashIterations);

              case 7:
                digest = _context3.sent;
                accessKey = ArweaveUtils.bufferTob64(digest.slice(0, 15));
                _context3.next = 11;
                return this.hash(digest.slice(16, 31), 1);

              case 11:
                encryptionkey = _context3.sent;
                return _context3.abrupt("return", new SiloResource(siloURI, accessKey, encryptionkey));

              case 13:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function parseUri(_x4) {
        return _parseUri.apply(this, arguments);
      }

      return parseUri;
    }()
  }, {
    key: "hash",
    value: function () {
      var _hash = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee4(input, iterations) {
        var digest, count;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return this.crypto.hash(input);

              case 2:
                digest = _context4.sent;
                count = 0;

              case 4:
                if (!(count < iterations - 1)) {
                  _context4.next = 11;
                  break;
                }

                _context4.next = 7;
                return this.crypto.hash(digest);

              case 7:
                digest = _context4.sent;

              case 8:
                count++;
                _context4.next = 4;
                break;

              case 11:
                return _context4.abrupt("return", digest);

              case 12:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function hash(_x5, _x6) {
        return _hash.apply(this, arguments);
      }

      return hash;
    }()
  }]);

  return Silo;
}();

exports.default = Silo;

var SiloResource =
/*#__PURE__*/
function () {
  function SiloResource(uri, accessKey, encryptionKey) {
    _classCallCheck(this, SiloResource);

    this.uri = uri;
    this.accessKey = accessKey;
    this.encryptionKey = encryptionKey;
  }

  _createClass(SiloResource, [{
    key: "getUri",
    value: function getUri() {
      return this.uri;
    }
  }, {
    key: "getAccessKey",
    value: function getAccessKey() {
      return this.accessKey;
    }
  }, {
    key: "getEncryptionKey",
    value: function getEncryptionKey() {
      return this.encryptionKey;
    }
  }]);

  return SiloResource;
}();

exports.SiloResource = SiloResource;